export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyBSKUb1cpUj7zwFDczx6IiUbHNYsPiMZw8',
};
